module.exports = __webpack_public_path__ + "img/floodfighting-20160720-01-768x1024.55e10505.jpg";